module.exports = __webpack_public_path__ + "why7.png?b43844bc5e6cdc13e3cfc2c755b1c6ab";